var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Png(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 66",
    enableBackground: "new 0 0 54 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "51.5,63.9 2.5,63.9 2.5,2.1 36.7,2.1 51.5,17.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,64.5H2v-63h34.9l15.1,16V64.5z M3.1,63.4h47.8V17.9L36.4,2.6H3.1V63.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M52,64.5H2v-63h35.3L52,16.4V64.5z M3.1,63.4h47.8V16.8L36.8,2.6H3.1V63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M39.2,22.6l-3.1,3.9l-5.8-7.3c0,0-3.9,6.6-6,9.9c-1.1-0.4-2.2-0.7-3.4-0.7c-5,0-9.1,3.9-9.4,8.8l0,0h0 c0,0,0,0,0,0.1h18.7c0,0,0,0,0-0.1h12.2L39.2,22.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBCBCB",
    cx: 18.7,
    cy: 17.8,
    r: 4.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5C5C5",
    points: "37.1,2.1 37.1,16.6 51.5,16.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 42.5,
    fill: "#969594",
    width: 48.9,
    height: 21.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969594",
    d: "M52,64.5H2V42h50V64.5z M3.1,63.4h47.8V43.1H3.1V63.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21,50.8c0,0.9-0.3,1.7-1,2.2c-0.6,0.5-1.6,0.8-2.7,0.8h-1.1v3.6h-1.1v-9.3h2.4C19.9,48.1,21,49,21,50.8z  M16.2,52.7h1c1,0,1.6-0.2,2.1-0.5c0.4-0.3,0.6-0.8,0.6-1.5c0-0.6-0.2-1.1-0.6-1.4c-0.4-0.3-1-0.4-1.9-0.4h-1.2V52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.9,57.3h-1.2l-5.1-7.8h0c0.1,0.9,0.1,1.8,0.1,2.5v5.3h-1v-9.3h1.2l5.1,7.7H29c0-0.1,0-0.5-0.1-1.1 c0-0.6,0-1.1,0-1.3v-5.3h1V57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.3,52.5h3.1V57c-0.5,0.2-1,0.3-1.5,0.4c-0.5,0.1-1.1,0.1-1.8,0.1c-1.4,0-2.5-0.4-3.3-1.3 c-0.8-0.8-1.2-2-1.2-3.5c0-1,0.2-1.8,0.6-2.5c0.4-0.7,0.9-1.3,1.7-1.7s1.6-0.6,2.6-0.6c1,0,1.9,0.2,2.8,0.5l-0.4,1 c-0.8-0.4-1.6-0.5-2.4-0.5c-1.1,0-2,0.3-2.6,1c-0.6,0.7-1,1.6-1,2.8c0,1.3,0.3,2.2,0.9,2.8c0.6,0.6,1.5,1,2.7,1 c0.6,0,1.3-0.1,1.9-0.2v-2.9h-2.1V52.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Png);
export default __webpack_public_path__ + "static/media/07-png.15c7396ccce253df097c1e0fef051a1f.svg";
export { ForwardRef as ReactComponent };